import React from "react";
import ReactDOM from "react-dom/client";

export default async (Component, data, node) => {
  const root = ReactDOM.createRoot(node);
  root.render(<Component {...data} />);
};
